import { Input } from '@/components/ui/input'
import type { InputProps } from '../input-props'

export function TimeInput({ value, onChange, onBlur, disabled, invalid }: InputProps) {
  return (
    <Input
      type="time"
      value={(value as string) ?? ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
      aria-invalid={invalid || undefined}
      dir="ltr"
    />
  )
}
